// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__2J5Bl","input":"Detail_input__22kwH","card":"Detail_card__2x4-F"};